export default __webpack_public_path__ + "static/media/mastery-bar-pane.4cb3d806.png";